import { useMemo } from 'react'

import { type MediaType } from '../vault.constants'
import {
  isZeroViews,
  passesCategoryFilter,
} from '../vault.helpers'

const PER_PAGE = 24

type Args = {
  media: any[]
  activeFilter: string
  postsFilter: MediaType
  unreleasedOnly: boolean
  showPaidOnly: boolean
  postsGrouped: string | boolean
  activeCategory: any[]
}

export function useVaultFilteredMedia({
  media,
}: Args) {
  const filteredMedia = useMemo(() => {
    return Array.isArray(media) ? media : []
  }, [media])

  const shouldPaginate = filteredMedia.length >= PER_PAGE

  return {
    filteredMedia,
    shouldPaginate,
  }
}